import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCallback } from 'react';
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import TableModule from '../../components/TableModule';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faRotate, faCircleArrowLeft, faXmark, faClipboardCheck, faSearch } from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";
import './RolForm.css';

const RolForm = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [code, setCode] = useState("");
    const [description, setDescription] = useState("");
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 10;
    const [selectedModules, setSelectedModules] = useState([]);
    const [search, setSearch] = useState('');
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchRol = async () => {
                try {
                    const response = await apiClient.get(`/admin/roles/${id}`);
                    setCode(response.data.code);
                    setDescription(response.data.description);

                } catch (error) {
                    console.error("Error al cargar el rol", error);
                }
            };
            fetchRol();
        }
    }, [id]);

    const fetchAllData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/admin/permissions`);

            if (Array.isArray(response.data)) {
                setData(response.data);
                setTotalItems(response.data.length);
            } else {
                setData([response.data]);
                setTotalItems(1);
            }
        } catch (error) {
            setIsErrorVisible(true);
        } finally {
            setIsSuccessVisible(true);
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]);

    const handleRefresh = () => {
        setSearch("");
        setCurrentPage(1);
        fetchAllData();
    };

    const handleCheckboxChange = (code) => {
        setSelectedModules(prevSelected =>
            prevSelected.includes(code)
                ? prevSelected.filter(selectedCode => selectedCode !== code)
                : [...prevSelected, code]
        );
    };

    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };

    const handleSelectAll = () => {
        const currentPageItems = data.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
        );

        const currentPageCodes = currentPageItems.map(item => item.code);

        const allSelectedInPage = currentPageCodes.every(code => selectedModules.includes(code));

        setIsAllSelected(!allSelectedInPage);

        if (allSelectedInPage) {
            // Deselecciona solo los de la página actual
            setSelectedModules(prev =>
                prev.filter(code => !currentPageCodes.includes(code))
            );
        } else {
            // Añade los que no están seleccionados de esta página
            setSelectedModules(prev => Array.from(new Set([...prev, ...currentPageCodes])));
        }
    };

    const handleSearch = useCallback(async (page = 1) => {
        try {
            // Construir la URL con los query params
            const params = new URLSearchParams();
            if (search) params.append('search', search);
            //const response = await apiClient.get(`/admin/permissions?${params.toString()}&page=${page}`);
            const response = await apiClient.get(`/admin/permissions?${params.toString()}`);
            if (Array.isArray(response.data)) {
                setData(response.data);
                setTotalItems(response.data.length);
            } else {
                setData([response.data]);
                setTotalItems(1);
            }
            setCurrentPage(1);
        } catch (error) {
            setIsErrorVisible(true);
        }
    }, [search]);

    const columns = [
        { title: "Id", key: "id" },
        { title: "Código", key: "code" },
        { title: "Descripción", key: "name" },
        { title: "Seleccionar", key: "acciones" },
    ];

    const renderRow = (item, index) => (
        <>
            <td>{item.id}</td>
            <td>{item.code}</td>
            <td>{item.description}</td>
            <td>
                <input
                    type="checkbox"
                    checked={selectedModules.includes(item.code)}
                    onChange={() => handleCheckboxChange(item.code)}
                />
            </td>
        </>
    );


    const validateFields = () => {
        let validationErrors = {};
        const onlyLetters = /^[a-zA-Z]+$/;
        if (!code) {
            validationErrors.code = "El Campo es Obligatorio";
        } else if (!onlyLetters.test(code)) {
            validationErrors.code = "Solo se permiten letras";
        }
        if (!description) validationErrors.description = "El Campo es Obligatorio";
        return validationErrors;
    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            let response;
            if (id) {
                const payloadUpdate = {
                    description
                };
                response = await apiClient.patch(
                    `/admin/roles/${id}`,
                    payloadUpdate
                );
                if (response.status === 200) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setIsLoginVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/RolList");
                }
            } else {
                const payload = {
                    code,
                    description,
                    permissions: selectedModules
                };
                response = await apiClient.post("/admin/roles", payload);
                if (response.status === 201) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/RolList");
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("ROLE_ALREADY_EXIST")) {
                setMessageBlock("El Rol ya existe.");
                setNotificationBlock(true);
            }
            else {
                setErrorMessage("Oops!. Ocurrió un error al crear el Rol");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Roles" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/RolList");
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del ROL</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.code ? "red" : "revert-layer" }}>
                            Código
                        </label>
                        <input
                            type="text"
                            placeholder="Código"
                            value={code}
                            //onChange={(e) => setCode(e.target.value)}
                            onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                if (/^[A-Z]*$/.test(value)) {
                                    setCode(value);
                                }
                            }}
                            readOnly={!!id}
                        />
                        {errors.code && <p className="error-message">{errors.code}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.description ? "red" : "revert-layer" }}>
                            Descripción
                        </label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                        {errors.description && <p className="error-message">{errors.description}</p>}
                    </div>
                    {!id && (
                        <>
                            <div className="basic-info-form-group">
                                <label>Permisos</label>
                                {/*SEARCH */}
                                <div className="filter-form">
                                    <div className="basic-info-form-group">
                                        <input
                                            type="text"
                                            id="customer"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            placeholder="Permiso"
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearch();
                                                }
                                            }}
                                        />
                                    </div>
                                    <button className="basic-custom-button" onClick={handleSearch}>
                                        <FontAwesomeIcon icon={faSearch} className="basic-shortcut-icon" />
                                        Buscar
                                    </button>
                                </div>
                            </div>
                            <div className="basic-info-form-group-add">
                                <label>Permisos seleccionados</label>
                                <div className="permit-list">
                                    {selectedModules.length > 0
                                        ? selectedModules.map((permId) => {
                                            const perm = data.find(r => r.code === permId);
                                            return (
                                                <div key={permId} className="permit-chip">
                                                    {perm ? perm.description : permId}
                                                    <span
                                                        className="chip-close"
                                                        onClick={() => handleCheckboxChange(permId)}
                                                    >
                                                        ×
                                                    </span>
                                                </div>
                                            );
                                        })
                                        : <p>No hay permisos seleccionados</p>
                                    }
                                </div>
                            </div>
                        </>
                    )}
                </div>
                {!id && (
                    <div className="rol-basic-info-form-group">
                        <TableModule
                            title="Lista de Permisos"
                            rows={data}
                            columns={columns}
                            icon={faClipboardCheck}
                            renderRow={renderRow}
                            currentPage={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={setCurrentPage}
                            onRefresh={handleRefresh}
                            onSelectAll={handleSelectAll}
                            isAllSelected={isAllSelected}
                            loading={loading}
                            select={true}
                        />
                    </div>
                )}
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/RolList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    id
                        ? "El Rol se ha Actualizado Correctamente."
                        : "El Rol se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuelve a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Rol debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={"/RolList"}
                    whatsApp={false} 
                />
            )}
        </div>
    );
};

export default RolForm;
